import { useContext } from "react";
import { LocaleContext } from "../state/LocaleContext.js";

/**
 * Generic "not found" page — shown for unmatched routes and for
 * ProjectDetail lookups that 404 (unknown group/page slug).
 */
export default function NotFound() {
  const { tUI } = useContext(LocaleContext);

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center px-3"
      style={{ minHeight: "calc(100vh - 70px)", backgroundColor: "#fff", color: "#111827" }}
    >
      <div style={{ fontSize: "4rem", fontWeight: "bold", color: "var(--theme-accent, #FFC300)" }}>404</div>
      <h1 className="fs-4 fw-bold mb-2">{tUI("label_page_not_found_title", "Page Not Found")}</h1>
      <p className="mb-4" style={{ color: "#627076", maxWidth: "480px" }}>
        {tUI("label_page_not_found_body", "The page you're looking for doesn't exist or may have moved.")}
      </p>
      <a
        href="/"
        className="btn fw-semibold text-uppercase"
        style={{
          backgroundColor: "var(--theme-accent, #FFC300)",
          color: "var(--theme-primary-dark, #2E3C47)",
          padding: "10px 24px",
          textDecoration: "none",
        }}
      >
        {tUI("label_back_to_home", "Back to Home")}
      </a>
    </div>
  );
}
